import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm1 2.051C23.921 2.543 29.457 8.079 29.949 15H17V2.051zM16 30C8.28 30 2 23.72 2 16 2 8.618 7.747 2.567 15 2.051V16c0 .276.112.526.293.707l9.861 9.861A13.922 13.922 0 0116 30zm10.568-4.846L18.414 17h11.535a13.919 13.919 0 01-3.381 8.154z"></path>
        </svg>
    );
}